import axios from "axios";
import auth from "components/user/services/Auth";
import { store } from "store";
import { setError } from "store/reducers/errors";
import { clearPopup } from "store/reducers/popup";

// import { RouteConstants } from "../../components/route/services/RouteConstants";
// import { ConstantValues } from "../util/Constants";
// import history from "../../store/history";
import logger from "utils/logger";
// import { isValidTaxYear } from "../util/CommonUtil";
// import { returnTaxYear } from "../util/YoyUtil";
// import StoreProvider from "../../store/storeProvider";

export const BASE_API_URL = process.env.REACT_APP_BASE_URL;
export const returnTaxYear = Object.freeze({
    0: "shared",
});

class Api {
    service
    constructor() {
        const service = axios.create({});
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
    }

    handleSuccess = (response: any) => {
        return response;
    };

    handleError = (error: any) => {
        if (error.config) {
            if (!this.handleExitedErrors()) {
                if (error.response && error.response.status === 401) {
                    if (auth.isAuthenticated()) {
                        // we still have a token but CAS has revoked it, sign out
                        logger.addPageAction("handleError from Api.js", {
                            error: error.response.errorDescription,
                            description: "we still have a token but CAS has revoked it, sign out",
                            tokenTimeToLive: auth.getTokenTimeToLive()
                        });
                        auth.logout();
                    } else {
                        window.location.pathname = "/"; //login again if session out
                    }
                    return;
                }
                if (error) {
                    this.handleDisplayError(parseInt(error.response?.status || 404)); //throw 404 if network error
                }
                throw error;
            }
        }
        return error.response;
    };

    /* This function is removed when all error codes handled in pages */
    handleExitedErrors = () => {
        let returnValue = false;
        return returnValue;
    };

    handleDisplayError = (statusCode: number) => {
        store.dispatch(clearPopup())
        store.dispatch(setError(statusCode));
    };
    getRequestHeaders(isShared = false) {
        // Get the current tax year from the current paathname.
        // This tax year logic might need to change later if we update our routing.
        let taxYear: string | number = 0;
        try {
            taxYear = document.location.pathname.split("/")[1];
        } catch (ex) {
            // const Constants = ConstantValues.getData();
            // If we couldn't grab a year, default to taxyear.
            taxYear = 2025;
        }

        if (auth.isAuthenticated()) {
            let head = {
                Authorization: "Bearer " + auth.getAccessToken(),
                "X-api-version": !isShared ? `${taxYear}.0` : `1.0`
            };
            return head;
        }

        // return { "X-api-version": !isShared ? `${taxYear}.0` : `1.0` };
    }


    get(path: string) {
        return this.service.request({
            method: "GET",
            headers: this.getRequestHeaders(),
            url: `${BASE_API_URL}${path}`
        });
    }

    post(path: string, payload: any) {
        return this.service.request({
            method: "POST",
            headers: this.getRequestHeaders(),
            url: `${BASE_API_URL}${path}`,
            data: payload
        });
    }

    // patch(path, payload) {
    //     return this.service.request({
    //         method: "PATCH",
    //         headers: this.getRequestHeaders(),
    //         url: `${this.getBasePath()}${path}`,
    //         data: payload
    //     });
    // }

    put(path: string, payload: any = {}) {
        return this.service.request({
            method: "PUT",
            headers: this.getRequestHeaders(),
            url: `${BASE_API_URL}${path}`,
            responseType: "json",
            data: payload
        });
    }

    delete(path: string) {
        return this.service.request({
            method: "DELETE",
            headers: this.getRequestHeaders(),
            url: `${BASE_API_URL}${path}`,
            responseType: "json"
        });
    }
}

const api = new Api();
export default api;
